export default __webpack_public_path__ + "static/emoji-61c91ff087fe664b42e4406d3e93d057.svg";